
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./css/SideNav.css";
import vect from "./images/SideNav/Calendar1.png";
import vect2 from "./images/SideNav/Statistics1.png";
import Order1 from "./images/SideNav/Order1.png";
import Inventorymanagement1 from "./images/SideNav/Inventorymanagement1.png";
import Diningtable from "./images/SideNav/Diningtable withchairs1.png";
import Right from "./images/SideNav/right-arrow.png";
import Down from "./images/SideNav/down-arrow.png";
import Menu1 from "./images/SideNav/Menu1.png";
import logoutImg from "./images/power3.png";
import "./css/SideNav.css";
import vect1 from "./images/SideNav/Checklist1.png";
import vect3 from "./images/SideNav/Vector1.png";
import vect4 from "./images/SideNav/msg.png";
import vect5 from "./images/SideNav/sett.png";
import vect6 from "./images/SideNav/vec.png";
import vect7 from "./images/SideNav/vec1.png";
import back from "./images/icons/back.png";
import dot from "./images/icons/dot.png";

import { DBContext } from './DBContext'
import { DineContext } from './DineContext'

function SideNavMob({ focus }) {

    const { logginedDB , name , fetchData , inventoryState , sideNavState , setInventoryStateFunc , sideNavStateFunc, hasPermission, logout } = useContext(DBContext);
    const { clearDineState } = useContext(DineContext);

    const navigate = useNavigate();

    const [orderBillingContents, setOrderBillingContents] = useState(false);

    const toNavigate = (path) => {
        navigate(path);
        sideNavStateFunc(sideNavState)
    };

    const handleInventory = () => {
        navigate('/Inventory');
        setInventoryStateFunc(true)
    };

    const toInventory = (page) => {
        navigate(page ? `/Inventory/${page}` : '/Inventory');
        setInventoryStateFunc(true)
        sideNavStateFunc(sideNavState)
    };

    const order_Billing = () => {
        sideNavStateFunc(!sideNavState)
        setOrderBillingContents(!orderBillingContents);
    };

    const [reportContents, setReportContents] = useState(false);
    const [purchaseContents, setPurchaseContents] = useState(false);
    const [consumptionContents, setConsumptionContents] = useState(false);
    const [conversionContents, setConversionContents] = useState(false);

    const report = () => {
        setReportContents(!reportContents);
        setPurchaseContents(false);
        setConsumptionContents(false)
        setConversionContents(false)
    };

    const purchase = () => {
        setPurchaseContents(!purchaseContents);
        setReportContents(false);
        setConsumptionContents(false)
        setConversionContents(false)
    };

    const consumption = () => {
        setConsumptionContents(!consumptionContents);
        setReportContents(false);
        setPurchaseContents(false);
        setConversionContents(false)
    };

    const conversion = () => {
        setConversionContents(!conversionContents);
        setReportContents(false);
        setPurchaseContents(false);
        setConsumptionContents(false)
    };

    const [mouseEnter,setMouseEnter] = useState(false)

    const handleMouseEnter = () => {
        setMouseEnter(true);
    };

    const handleMouseLeave = () => {
        if (!sideNavState) {
            setOrderBillingContents(false);
            setMouseEnter(false)
            setReportContents(false);
            setPurchaseContents(false);
            setConsumptionContents(false)
            setConversionContents(false)
        }
    };

    useEffect(() => {
        if (!sideNavState) {
            handleMouseLeave()
        }
    },[sideNavState])

    const handleLogout = () => {
        logout();
        clearDineState();
        navigate("/");
    };

    useEffect(() => {
        window.onpopstate = () => {
            if (!logginedDB) {
                navigate("/");
            }
        };
    }, [logginedDB]);

    const handleBackToBilling = () => {
        setInventoryStateFunc(false)
        navigate('/ViewDashboard')
    }

    return (
        <div className='w-max h-full flex flex-col border-none z-[99999] transition-all duration-300 ease-in-out bg-[#f5f5f5] text-[0.875rem] p-3 overflow-auto noScroll'>
            {
                inventoryState ? (
                    <div className={`relative ${sideNavState ? 'SideNavState w-[18rem]' : 'SideNav w-[2.938rem] hover:w-[18rem]'} shadow-xl h-full max-h-full flex flex-col transition-all duration-300 ease-in-out gap-3 border-l border-r border-b bg-[#f5f5f5]`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        <div className={`w-full h-full shadow-md flex flex-col bg-[#fff] overflow-x-hidden overflow-y-auto ${sideNavState ? 'customScroll' : mouseEnter ? 'customScroll' : !sideNavState && 'noScroll'}`} >
                            <div
                                className={`SideNav_img w-full  cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                onClick={handleBackToBilling}
                            >
                                <img src={back} alt="<-" />
                                <span className="">Back To Billing</span>
                            </div>
                            <div
                                className={`SideNav_img w-full  cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center`}
                                onClick={() => toInventory()}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Inventory Dashboard</span>
                            </div>
                            <div
                                className={`SideNav_img relative w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex justify-start items-center `}
                                onClick={() => {
                                    report();
                                }}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="w-full">Report</span>
                                {reportContents ? (
                                    <img className="rightImage" src={Down} alt="<" />
                                ) : (
                                    <img className="rightImage" src={Right} alt=">" />
                                )}
                            </div>
                            
                            <div className={`transition-all ease-in-out ${
                                reportContents ? "max-h-screen opacity-100 duration-500" : "max-h-0 opacity-0 overflow-hidden duration-300"
                            }`}>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("stock")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Current Stock</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("stock-summary")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Stock Summary</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("stock-valuation")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Stock Valuation</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("low-stock-report")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Low Stock Report</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("raw-material-report")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Raw Material Report</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("consumption")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Consumption</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("opening-closing")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Opening - Closing</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("purchase")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Purchase</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("sales-report")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Sales</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("wastage-report")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Wastage</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center`}
                                    onClick={() => toInventory("supplier")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Supplier</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("internal-transfer")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Internal Transfer</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("item-wise-internal-transfer")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Item Wise Internal Transfer</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("manual-adjustment-report")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Manual Adjustment Report</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("food-costing")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Food Costing</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("recipe-cost-report")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Recipe Cost Report</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center`}
                                    onClick={() => toInventory("orderwise-consumption")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Orderwise Consumption</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("purchase-order-variance")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Purchase Order Variance</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("monthly")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Monthly</span>
                                </div>
                                <div
                                    className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                    onClick={() => toInventory("purchase-order-approval-report")}
                                >
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Purchase Order Approval Report</span>
                                </div>
                            </div>
                            <div
                                className={`SideNav_img relative w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex justify-start items-center `}
                                onClick={() => {
                                    purchase();
                                }}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Purchase</span>
                                {purchaseContents ? (
                                    <img className="rightImage" src={Down} alt="<" />
                                ) : (
                                    <img className="rightImage" src={Right} alt=">" />
                                )}
                            </div>
                            <div className={`transition-all ease-in-out ${purchaseContents ? "max-h-screen opacity-100 duration-500" : "max-h-0 opacity-0 overflow-hidden duration-300"}`}>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("purchase-indent")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Purchase Indent</span>
                                </div>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("purchase-order")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Purchase Order</span>
                                </div>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("grn")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Goods Receipt Note</span>
                                </div>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("stock-purchase")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Stock Purchase</span>
                                </div>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("purchase-return")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Purchase Return</span>
                                </div>
                            </div>
                            <div
                                className={`SideNav_img relative w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex justify-start items-center `}
                                onClick={() => {
                                    consumption();
                                }}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Consumption</span>
                                {consumptionContents ? (
                                    <img className="rightImage" src={Down} alt="<" />
                                ) : (
                                    <img className="rightImage" src={Right} alt=">" />
                                )}
                            </div>
                            <div className={`transition-all ease-in-out ${consumptionContents ? "max-h-screen opacity-100 duration-500" : "max-h-0 opacity-0 overflow-hidden duration-300"}`}>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("consumption-entry")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Consumption Entry</span>
                                </div>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("wastage")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Wastage Entry</span>
                                </div>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("orderwise-consumption")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Orderwise Consumption</span>
                                </div>
                            </div>
                            <div
                                className={`SideNav_img relative w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex justify-start items-center `}
                                onClick={() => {
                                    conversion();
                                }}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Conversion</span>
                                {conversionContents ? (
                                    <img className="rightImage" src={Down} alt="<" />
                                ) : (
                                    <img className="rightImage" src={Right} alt=">" />
                                )}
                            </div>
                            <div className={`transition-all ease-in-out ${conversionContents ? "max-h-screen opacity-100 duration-500" : "max-h-0 opacity-0 overflow-hidden duration-300"}`}>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("conversion")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Stock Conversion</span>
                                </div>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("production-conversion")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Production Conversion</span>
                                </div>
                                <div className="SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center" onClick={() => toInventory("yield-management")}>
                                    <img src={dot} alt="Dashboard" />
                                    <span className="contents">Yield Management</span>
                                </div>
                            </div>
                            <div
                                className={`SideNav_img w-full  cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                onClick={() => toInventory("raw-materials")}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Raw Materials</span>
                            </div>
                            <div
                                className={`SideNav_img  w-full  cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center`}
                                onClick={() => toInventory("item-recipes")}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Item Recipes</span>
                            </div>
                            <div
                                className={`SideNav_img w-full  cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                onClick={() => toInventory("suppliers")}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Suppliers</span>
                            </div>
                            <div
                                className={`SideNav_img w-full  cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                onClick={() => toInventory("units")}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Units</span>
                            </div>
                            <div
                                className={`SideNav_img  w-full  cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center`}
                                onClick={() => toInventory("suppliers-hub")}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Suppliers Hub</span>
                            </div>
                            <div
                                className={`SideNav_img w-full  cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                onClick={() => toInventory("inventory-approval-flow")}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Inventory Approval Flow</span>
                            </div>
                            <div
                                className={`SideNav_img w-full  cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                onClick={() => toInventory("email-template-setting")}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Email Template Setting</span>
                            </div>
                            <div
                                className={`SideNav_img w-full cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center `}
                                onClick={() => toInventory("inventory-settings")}
                            >
                                <img src={Inventorymanagement1} alt="<-" />
                                <span className="">Inventory Settings</span>
                            </div>
                        </div>
                        {/* <div className="w-full h-max sticky bottom-0 bg-[#fff] shadow-md">
                            <div
                                className={`SideNav_img w-full h-max cursor-pointer transition-colors duration-300 ease-in bg-[#fff] flex items-center ${focus === "Logout" ? "bg-[#B0B0B0]" : "bg-[#f5f5f5]"}`}
                                onClick={handleLogout}
                            >
                                <img src={logoutImg} alt="Settings" />
                                <span className="">Logout</span>
                            </div>
                        </div> */}
                    </div>
                ) : (
                    <div className={sideNavState ? 'w-max flex h-full flex-col text-nowrap font-nunito' : 'hidden'} >
                        <div className="w-full h-full flex flex-col overflow-auto noScroll">
                            {hasPermission('viewDashboard') && (
                                <div
                                    className={`w-full h-max  cursor-pointer transition-colors duration-300 ease-in flex items-center py-[.75rem] pr-[.75rem] gap-2 `}
                                    onClick={() => toNavigate("/ViewDashboard", 0)}
                                >
                                    <img className="w-[1rem]" src={vect2} alt="Dashboard" />
                                    <span className="">Dashboard</span>
                                </div>
                            )}
                            <div
                                className={` w-full h-max relative cursor-pointer transition-colors duration-300 ease-in flex items-center py-[.75rem] pr-[.75rem] gap-2 `}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    order_Billing();
                                }}
                            >
                                <img className="w-[1rem]" src={Order1} alt="Order" />
                                <span className="">Order & Billing</span>
                                {orderBillingContents ? (
                                    <img className="absolute right-2 w-[.75rem]" src={Down} alt="<" />
                                ) : (
                                    <img className="absolute right-2 w-[.75rem]" src={Right} alt=">" />
                                )}
                            </div>

                            <div className={`transition-all ease-in-out ${
                                orderBillingContents ? "max-h-screen opacity-100 duration-500" : "max-h-0 opacity-0 overflow-hidden duration-300"
                            }`}>
                                <div
                                    className={` w-full h-max  cursor-pointer transition-colors duration-300 ease-in  flex items-center py-[.75rem] pr-[.75rem] gap-2 `}
                                    onClick={() => toNavigate("/AllOrders", 0)}
                                >
                                    <img className="w-[1rem]" src={dot} alt="Dashboard" />
                                    <span className="">All Orders</span>
                                </div>
                                <div
                                    className={` w-full h-max  cursor-pointer transition-colors duration-300 ease-in flex items-center py-[.75rem] pr-[.75rem] gap-2 `}
                                    onClick={() => toNavigate("/AllOrders", 0)}
                                >
                                    <img className="w-[1rem]" src={dot} alt="Dashboard" />
                                    <span className="">Online Orders</span>
                                </div>
                                <div
                                    className={` w-full h-max  cursor-pointer transition-colors duration-300 ease-in flex items-center py-[.75rem] pr-[.75rem] gap-2`}
                                    onClick={() => toNavigate("/KitchenDisplaySystem", 8)}
                                >
                                    <img className="w-[1rem]" src={dot} alt="Dashboard" />
                                    <span className="">Kitchen Display</span>
                                </div>
                            </div>

                            <div
                                className={` w-full h-max  cursor-pointer transition-colors duration-300 ease-in  flex items-center py-[.75rem] pr-[.75rem] gap-2`}
                                onClick={() => toNavigate("/TableView", 2)}
                            >
                                <img className="w-[1rem]" src={Diningtable} alt="Dining" />
                                <span className="">Tables</span>
                            </div>
                            {hasPermission('manageMasters') && (
                                <div
                                    className={` w-full h-max  cursor-pointer transition-colors duration-300 ease-in  flex items-center py-[.75rem] pr-[.75rem] gap-2 `}
                                    onClick={() => toNavigate("/Menu")}
                                >
                                    <img className="w-[1rem]" src={Menu1} alt="Menu Management" />
                                    <span className="">Menu Management</span>
                                </div>
                            )}
                            <div
                                className={` w-full h-max  cursor-pointer transition-colors duration-300 ease-in  flex items-center py-[.75rem] pr-[.75rem] gap-2 `}
                                onClick={handleInventory}
                            >
                                <img className="w-[1rem]" src={Inventorymanagement1} alt="Inventory Management" />
                                <span className="">Inventory</span>
                            </div>
                            {/* <div
                                className={` w-full h-max  cursor-pointer transition-colors duration-300 ease-in  flex items-center py-[.75rem] pr-[.75rem] gap-2 `}
                                onClick={() => toNavigate("/ViewDashboard", 5)}
                            >
                                <img className="w-[1rem]" src={vect} alt="Calendar" />
                                <span className="">CRM</span>
                            </div> */}
                            {hasPermission('manageSettings') && (
                                <div
                                    className={` w-full h-max  cursor-pointer transition-colors duration-300 ease-in  flex items-center py-[.75rem] pr-[.75rem] gap-2 `}
                                    onClick={() => toNavigate("/billerapp", 5)}
                                >
                                    <img className="w-[1rem]" src={vect} alt="Calendar" />
                                    <span className="">User Management</span>
                                </div>
                            )}
                            <div
                                className={` w-full h-max  cursor-pointer transition-colors duration-300 ease-in  flex items-center py-[.75rem] pr-[.75rem] gap-2 `}
                                onClick={() => toNavigate("/ViewDashboard", 6)}
                            >
                                <img className="w-[1rem]" src={vect7} alt="Vector" />
                                <span className="">Accounting</span>
                            </div>
                            {hasPermission('manageSettings') && (
                                <div
                                    className={` w-full h-max  cursor-pointer transition-colors duration-300 ease-in  flex items-center py-[.75rem] pr-[.75rem] gap-2 `}
                                    onClick={() => toNavigate("/ViewDashboard", 7)}
                                >
                                    <img className="w-[1rem]" src={vect5} alt="Settings" />
                                    <span className="">Configuration</span>
                                </div>
                            )}
                        </div>
                            <div
                                className={`w-full h-max cursor-pointer transition-colors duration-300 ease-in  flex items-center pt-3 gap-2`}
                                onClick={handleLogout}
                            >
                                <img className="w-[1rem]"  src={logoutImg} alt="logout" />
                                <span className="">Logout</span>
                            </div>
                    </div>
                )
            }
        </div>
    );
}

export default SideNavMob;
